import { convertCRMDate } from "../../helper";
import {
  Claim,
  ClaimStatus,
  Contract,
  ContractStatus,
  PendingContract,
  PendingContractStatus,
} from "./types";

export const generateHTMLContent = (data, uploadedFileUrls) => {
  return `
        <div style="background-color: rgba(243, 248, 254, 0.4); padding: 0.5rem; border-radius: 0.5rem; overflow: hidden;">
  <table style="width: 100%; border-collapse: collapse;">
    <tr>
      <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        Email
      </td>
      <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        ${data.Email}
      </td>
    </tr>
    <tr>
      <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        Phone number
      </td>
      <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        ${data.phone}
      </td>
    </tr>
    <tr>
      <td style="color: #000; font-weight: 500; padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        Support Request Reason
      </td>
      <td style="padding: 0.5rem; border-bottom: 1px solid #d3d3d3;">
        ${data.help}
      </td>
    </tr>
    <tr>
      <td style="color: #000; font-weight: 500; padding: 0.5rem;">
        Message
      </td>
      <td style="padding: 0.5rem;">
        ${data.message}
      </td>
    </tr>
    ${
      uploadedFileUrls?.length > 0
        ? `
    <tr>
      <td style="color: #000; font-weight: 500; padding: 0.5rem; border-top: 1px solid #d3d3d3;">
        Attachments
      </td>
      <td style="padding: 0.5rem; border-top: 1px solid #d3d3d3;">
        <div style="display: flex; flex-wrap: wrap; gap: 1rem;">
          ${uploadedFileUrls
            .map((url) => {
              const isPdf = url.endsWith(".pdf");
              return `
              <div style="display: flex; align-items: center; margin:5px;">
                <a href="${url}" target="_blank" style="display: inline-block;">
                  ${
                    isPdf
                      ? `<img 
                          src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"
                          alt="PDF Icon" 
                          style="width: 75px; height: 75px; object-fit: cover; border: 1px solid #d3d3d3; border-radius: 0.25rem;" 
                        />`
                      : `<img 
                          src="${url}" 
                          alt="Image" 
                          style="width: 75px; height: 75px; object-fit: cover; border: 1px solid #d3d3d3; border-radius: 0.25rem;" 
                        />`
                  }
                </a>
              </div>
              `;
            })
            .join("")}
        </div>
      </td>
    </tr>`
        : ""
    }
  </table>
</div>
`;
};

export const mapApiClaim = (payload: any): any => {
  const customerInfo = extractCustomerInfo(payload["customer_summary"]);

  let warrantyNumber = payload?.["Warranty"]?.["name"] || "";
  if (!warrantyNumber && payload["Warranty.Name"]) {
    warrantyNumber = payload["Warranty.Name"];
  }

  return {
    id: payload["id"],
    claimNumber: payload["fpp_original_number"] || payload["Name"],
    warrantyNumber,
    customerName: customerInfo.name,
    customerAddress: customerInfo.address1,
    claimDate: convertCRMDate(payload["claim_date"]),
    dealer_id: payload?.["Dealer"]?.["id"] || "",
    status: mapClaimStatus(payload["bp_status"]),
    denied: payload["denied"],
  };
};

export const extractCustomerInfo = (customerSummary: string) => {
  customerSummary ||= "";
  const lines = customerSummary.split("\n");
  const customerInfo = {
    name: "",
    phone: "",
    email: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
  };

  lines.forEach((line) => {
    const [key, value] = line.split(": ");
    switch (key.toLowerCase()) {
      case "name":
        customerInfo.name = value;
        break;
      case "phone":
        customerInfo.phone = value;
        break;
      case "email":
        customerInfo.email = value;
        break;
      case "address1":
        customerInfo.address1 = value;
        break;
      case "city":
        customerInfo.city = value;
        break;
      case "state":
        customerInfo.state = value;
        break;
      case "zip":
        customerInfo.zip = value;
        break;
    }
  });

  return customerInfo;
};

export const mapApiSkus = (payload: any) => {
  return {
    planType: payload["dealer_plan_type"],
    sku: payload["gbs_billing_sku"],
  };
};

export const mapApiPendingContract = (payload: any): any => {
  return {
    id: payload["id"],
    contractNumber: payload["contract_number"],
    purchaseDate: convertCRMDate(payload["contract_purchase_date"]) ?? null,
    customerName: `${payload["customer_first_name"] || ""} ${
      payload["customer_last_name"] || ""
    }`.trim(),
    customerAddress: `${payload["customer_street_address_1"] || ""} ${
      payload["customer_street_address_2"] || ""
    }`.trim(),
    storeName: payload["selling_store_location"],
    salesPerson: payload["sales_person_id"],
    invoice: payload["invoice_number"],
    status: mapPendingContractStatus(payload["status"]),
    recordType: payload["record_type"],
    dealer_id: payload["dealer_id"],
  };
};

export const mapApiContract = (payload: any): any => {
  return {
    id: payload["id"],
    contractNumber: payload["Name"],
    deliveryDate: convertCRMDate(payload["delivery_date"]) ?? null,
    purchaseDate: convertCRMDate(payload["purchase_date"]) ?? null,
    expirationDate: convertCRMDate(payload["expiration_date"]) ?? null,
    customerName: payload?.["Contact"]?.["name"] || "",
    customerAddress: payload["customer_street1_1"],
    status: mapStatus(payload["bp_status"]),
    invoice: payload["invoice"] || "",
    dealer_id: payload?.["Dealer1"]?.["id"] || "",
  };
};

export const mapStatus = (status) => {
  const allStatus = {
    Active: ContractStatus.Active,
    Cancelled: ContractStatus.Cancelled,
    Expired: ContractStatus.Expired,
    "Cancel Request Dealer Review": ContractStatus.CancelRequestDealerReview,
    "Cancel Request Consumer Review":
      ContractStatus.CancelRequestConsumerReview,
  };
  return allStatus[status] || null;
};

export const mapPendingContractStatus = (status: string) => {
  const allStatus = {
    pending: PendingContractStatus.Pending,
    issue: PendingContractStatus.Issue,
    processed: PendingContractStatus.Processed,
    processing: PendingContractStatus.Processing,
  };
  return allStatus[status.toLowerCase()] || null;
};

export const mapClaimStatus = (status: string) => {
  const allStatus: any = {
    Draft: ClaimStatus.Draft,
    "Draft Reminder": ClaimStatus.DraftReminder,
    Adjudication: ClaimStatus.Adjudication,
    "Customer Action": ClaimStatus.CustomerAction,
    "CAR Response": ClaimStatus.CARResponse,
    Approved: ClaimStatus.Approved,
    Dispositioned: ClaimStatus.Disposition,
    "Non-Monetary": ClaimStatus.NonMonetary,
    "Store Referral": ClaimStatus.StoreReferral,
    "Soft Close": ClaimStatus.SoftClose,
    Closed: ClaimStatus.Closed,
    Denied: ClaimStatus.Denied,
    "Claimed Denied Customer Comm": ClaimStatus.ClaimedDeniedCustomerComm,
    Abandoned: ClaimStatus.Abandoned,
  };
  return allStatus[status] || null;
};
